export default __webpack_public_path__ + "static/media/blocks2.46c81561.png";